import { render } from "./ClinicConfigurationTab.vue?vue&type=template&id=0fbdd669&scoped=true"
import script from "./ClinicConfigurationTab.js?vue&type=script&lang=js&external"
export * from "./ClinicConfigurationTab.js?vue&type=script&lang=js&external"

import "./ClinicConfigurationTab.vue?vue&type=style&index=0&id=0fbdd669&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0fbdd669"]])

export default __exports__